import React, { useEffect } from "react";
import { Box, CircularProgress, Button } from "@mui/material";

import Typography from "@mui/material/Typography";
// import ApiHelper from "../../utillity/ApiHelper";
// import APIURLConstants from "../../config/config";
import Blogbg from "../../assets/blog/blogbg.png";
import InstagramIcon from "../../assets/insta.svg";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import { FeedCard } from "../../components/FeedCard/FeedCard";
import ApiHelper from "../../utillity/ApiHelper";
import APIURLConstants from "../../config/config";
import Header from "../../components/Header/Header";
import { NewFooter } from "../../components/NewFooter";
// import { Feeds } from "../../constants/Constant";
// import { useState } from "@hookstate/core";
// import FacebookIcon from "@mui/icons-material/Facebook";
import First from "../../assets/blog/1.png";
import Second from "../../assets/blog/2.png";
import Third from "../../assets/blog/3.png";
import Fourth from "../../assets/blog/4.png";
import Five from "../../assets/blog/5.png";
import Six from "../../assets/blog/6.png";
import Seven from "../../assets/blog/7.png";
import Eight from "../../assets/blog/8.png";
import Nine from "../../assets/blog/9.png";
import Ten from "../../assets/blog/10.png";

import NewBlogCard from "../../components/NewBlogCard";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../constants/RouteConstant";

export const Feed = () => {
	const [feeds, setFeeds] = React.useState([]);
	const [loading, setLoading] = React.useState(true);
	const navigate = useNavigate();

	const getFeedDetails = () => {
		ApiHelper.get(APIURLConstants.ALL_FEEDS)
			.then((res) => {
				setLoading(false);
				setFeeds(res.data.result.feed);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const getImage = (index) => {
		let num = index % 10;

		switch (num) {
			case 1:
				return Ten;
				break;
			case 1:
				return First;
				break;

			case 2:
				return Second;
				break;
			case 3:
				return Third;
				break;
			case 4:
				return Fourth;

				break;
			case 5:
				return Five;

				break;
			case 6:
				return Six;

				break;
			case 7:
				return Seven;

				break;
			case 8:
				return Eight;
				break;
			case 9:
				return Nine;
				break;

			default:
				return Five;

				break;
		}
	};
	useEffect(() => {
		getFeedDetails();
	}, []);

	const getCard = (data, index) => {
		return (
			<>
				<Box width={552} height={190} display={"flex"} borderRadius={4} gap={2}>
					<Box
						width={207}
						height={180}
						component={"img"}
						src={index === 10 ? Ten : Five}
						borderRadius={4}
					/>

					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							gap: 2,
							textAlign: "start",
						}}
					>
						<Typography
							component={"h4"}
							variant="inherit"
							fontSize="14px"
							fontWeight={500}
							color={"#697586"}
						>
							{/* feeds */}
							{moment(data.date).format("MMM Do YYYY") +
								" | By " +
								" " +
								"Admin"}
						</Typography>
						<Typography
							variant="inherit"
							fontSize="20px"
							fontWeight={500}
							color={"#121926"}
						>
							{/* feeds */}
							{data.title}
						</Typography>
						<Button
							size="small"
							color="secondary"
							onClick={() =>
								navigate(RouteConstants.FEED_DETAILS, {
									state: { feed: data, index: index },
								})
							}
							sx={{
								textTransform: "capitalize",
								textAlign: "start",
								display: "flex",
								flexDirection: "row",
								justifyContent: "start",
							}}
						>
							Learn More
						</Button>
					</Box>
				</Box>
			</>
		);
	};
	return (
		<>
			<Box
				sx={{
					background: `url(${Blogbg})`,
					backgroundSize: "100%",
					height: 304,
					// width: "auto",
				}}
			>
				<Box
					display={"flex"}
					flexDirection={"column"}
					justifyContent={"center"}
					textAlign={"center"}
					height={290}
				>
					<Typography
						component={"h4"}
						variant="inherit"
						fontSize="20"
						fontWeight={500}
						color={"#ffff"}
					>
						{"Articles & Resources"}
					</Typography>
					<Typography
						component={"h1"}
						variant="inherit"
						fontSize="58"
						fontWeight={600}
						color={"#ffff"}
					>
						{"Blog"}
					</Typography>
				</Box>
			</Box>

			{loading ? (
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						// height: "100%",
						width: "1280px",
						justifyContent: "center",
						alignContent: "center",
						alignItems: "center",
					}}
				>
					<CircularProgress
						sx={{
							color: "secondary.main",
						}}
					/>
				</Box>
			) : (
				<>
					{/* <Box
						sx={{
							display: "flex",
							flexDirection: "row",
						height: "100%",
							width: "1280px",
							justifyContent: "center",
							alignContent: "center",
							alignItems: "center",
							gap: 2,
							mx: "auto",
						}}
						 p={4}
					>
						<Box
							sx={{
								display: "flex",
								width: 668,
								height: 420,
								borderRadius: 4,
								p: 2,
								justifyContent: "center",
							}}
							onClick={() =>
								navigate(RouteConstants.FEED_DETAILS, {
									state: {
										feed: feeds && feeds.length > 0 && feeds[0],
										index: 1,
									},
								})
							}
						>
							<Box
								sx={{
									background: `url(${Fourth})`,
									backgroundSize: "cover",
									// height: 400,
									width: "80%",
									opacity: 1,
								}}
							>
								<Box
									display={"flex"}
									flexDirection={"column"}
									justifyContent={"space-between"}
								>
									<Box height={320}></Box>
									<Box p={4}>
										<Typography
											component={"h4"}
											variant="inherit"
											fontSize="20"
											fontWeight={500}
											color={"#121926"}
										>
										
											{moment(
												feeds && feeds.length > 0 && feeds[0].created_at
											).format("MMM Do YYYY") +
												" | By " +
												" " +
												"Admin"}
										</Typography>
										<Typography
											component={"h1"}
											variant="inherit"
											fontSize="58"
											fontWeight={600}
											color={"#121926"}
										>
											{feeds && feeds.length > 0 && feeds[0].title}
										</Typography>
									</Box>
								</Box>
							</Box>
						</Box>
						<Box display={"flex"} flexDirection={"column"} gap={4}>
							{getCard(feeds && feeds.length > 0 && feeds[1], 5)}
							{getCard(feeds && feeds.length > 0 && feeds[2], 10)}
						</Box>
					</Box> */}

					<Box
						sx={{
							display: "flex",
							flexWrap: "wrap",
							flexDirection: { xs: "column", md: "row" },
							justifyContent: "center",

							// paddingLeft: { xs: "0", md: "4em" },
							padding: { xs: "0", md: 4 },
							background: "#F8FAFC",
						}}
					>
						<Box
							display={"flex"}
							flexDirection={"column"}
							justifyContent={"center"}
							textAlign={"center"}
						>
							{/* <Typography
								component={"h1"}
								variant="inherit"
								fontSize="58"
								fontWeight={600}
								color={"#121926"}
							>
								{"Latest Blog Articles"}
							</Typography> */}
							{/* <Typography
								component={"h4"}
								variant="inherit"
								fontSize="18"
								fontWeight={500}
								color={"#697586"}
							>
								{
									"Stay updated with the latest trends, tips, and guides in game modding."
								}
							</Typography> */}
						</Box>
						<Box
							display={"flex"}
							justifyContent={"center"}
							flexWrap={"wrap"}
							alignSelf={"center"}
							mx={"auto"}
							p={4}
							gap={2}
						>
							{feeds.length > 0 &&
								feeds.map((product, index) => {
									return (
										index > 3 && (
											<NewBlogCard
												data={product}
												key={index}
												title={product.title}
												date={product.created_at}
												image={getImage(index)}
												author={"admin"}
												index={index}
											/>
										)
									);
								})}
						</Box>
					</Box>
				</>
			)}
		</>
	);
};
